import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '@core/providers/http/api.service';
import {
  AnoLectivoOption,
  ApiEnvelope,
  PaginatedEnvelope,
  PeriodoRenovacaoMatricula,
  PeriodoRenovacaoMatriculaCreateDto,
  PeriodoRenovacaoMatriculaListParams,
} from '../models/periodo-renovacao-matricula.model';

@Injectable({
  providedIn: 'root',
})
export class PeriodoRenovacaoMatriculaService {
  private readonly path = 'bolsa';

  constructor(private apiService: ApiService) {}

  /** GET /PeriodoRenovacaoMatricula — listagem paginada. */
  listarPeriodos(
    params: PeriodoRenovacaoMatriculaListParams
  ): Observable<PaginatedEnvelope<PeriodoRenovacaoMatricula>> {
    const httpParams = new HttpParams({
      fromObject: this.stripEmpty(params),
    });
    return this.apiService.get<PaginatedEnvelope<PeriodoRenovacaoMatricula>>(
      `${this.path}/PeriodoRenovacaoMatricula`,
      httpParams
    );
  }

  /** POST /PeriodoRenovacaoMatricula — criação de um novo período. */
  criarPeriodo(
    body: PeriodoRenovacaoMatriculaCreateDto
  ): Observable<ApiEnvelope<PeriodoRenovacaoMatricula>> {
    return this.apiService.post<ApiEnvelope<PeriodoRenovacaoMatricula>>(
      `${this.path}/PeriodoRenovacaoMatricula`,
      body,
      {
        headers: { 'Content-Type': 'application/json-patch+json', Accept: 'application/json' },
      }
    );
  }

  /** GET /getAllAnoLectivo — opções para o dropdown de Ano Lectivo. */
  getAnosLectivos(): Observable<AnoLectivoOption[]> {
    const httpParams = new HttpParams({
      fromObject: { pageNumber: 1, pageSize: 100 },
    });
    return this.apiService
      .get<{ data: AnoLectivoOption[] }>(`${this.path}/getAllAnoLectivo`, httpParams)
      .pipe(map((response) => response.data ?? []));
  }

  private stripEmpty(params: Record<string, any>): Record<string, string> {
    return Object.fromEntries(
      Object.entries(params)
        .filter(([, v]) => v !== null && v !== undefined && v !== '')
        .map(([k, v]) => [k, String(v)])
    );
  }
}
